"use client";

import type { FC } from "react";
import { SvgXml, type SvgXmlProps } from "../svgXml";
import svgs from "./richColorSvgs/svgs";
import type { SvgNameType } from "./richColorSvgs/types";

type OspSvgIconProps = Omit<SvgXmlProps, "xml"> & {
  name: SvgNameType | string;
  color?: string;
};

const OspSvgIcon: FC<OspSvgIconProps> = ({ color, name, ...restProps }) => {
  const SvgComponent = svgs[name as keyof typeof svgs];
  if (!SvgComponent) {
    return null;
  }
  return <SvgXml xml={SvgComponent} fill={color} {...restProps} />;
};

export default OspSvgIcon;
